require('./depositExpired.scss');

const step1 = require('./step1');
const step2 = require('./step2');
const step3 = require('./step3');
const successStep = require('./successStep');
const customErrors = require('./customErrors');
const {
    EURO_SYMBOL,
    PERCENTAGE_SYMBOL,
    PRECONTRACTUAL_DEPOSIT,
    BANKING_DEPOSIT_GENERIC_PRECONTRACTUAL,
    BANKING_DEPOSIT_GENERIC_CONTRACTUAL
} = require('constants/index');
const { MAIN_DEPOSIT } = require('constants/hiringProductInformation');
const {
    DEPOSIT_WNM,
} = require('constants/operationTypes');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const { getDateAndPlaceText } = require('routes/contractsView/utilities/contactCenter/depositsPrintedDocumentHelper');
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
const { DEPOSITS_INTEREST_BAND_COUNTRIES } = require('constants/flagBasedFeatures');

const getContract = (notAllowedTAECountriesRenewal = true, notAllowedTINCountriesRenewal = true, showGrossInterest = false) => ({
    title: 'contractsView-depositExpiredContractTitle',
    service: '....',
    last_step: 4,
    showIntervenerControls: true,
    SignParamsFn: 'deposit_loan_SignParams',
    define_steps: 3,
    successStepType: 'dynamic',
    showHelpBar: true,
    alternativePositionedCheckboxes: true,
    alternativeLegalTextHeight: '393px',
    errorTitle: 'contractsView-errorTitle',
    errorMessage: 'contractsView-errorMessage',
    errorBackButtonLabel: 'contractSummary-backToDeposits',
    errorBackButtonLink: '/myprofile/deposits',
    onCancelURL: '/myprofile/deposits',
    notShowConfirmationCheckboxes: true,
    tealiumStepsLabels: [
        'precontractual',
        'selection',
        'legalinfo',
        'confirmation',
    ],
    tealiumName: 'expirationDeposit',
    hireParamsFn: 'depositexpired_hireParamsFn',
    biggerLegalTexts: true,
    hasPolling: true,
    termsAndCondsKey: MAIN_DEPOSIT,
    productAlias: PRECONTRACTUAL_DEPOSIT,
    preContractualAlias: BANKING_DEPOSIT_GENERIC_PRECONTRACTUAL,
    contractualAlias: BANKING_DEPOSIT_GENERIC_CONTRACTUAL,
    isPrintedDocBase64: false,
    warningContractMessage: 'contractsView-contractsView_depositExpiredWarningMessage',
    code_op: DEPOSIT_WNM,
    getCustomPrintDocument: 'deposit_getCustomPrintDocument',
    bodyClass: 'printer-show-deposit-body',
    printDocumentTranslations: {
        signDate: getDateAndPlaceText(),
        clientName: formatText('contractsView-contractsView_depositPrintDocumentSignText'),
    },
    emailInfo: {
        templateCode: 'TD_01',
    },
    breadcrumb: [
        {
            text: 'breadcrumb-deposits',
            url: '/myprofile/deposits'
        },
        {
            text: 'contractsView-depositExpiredBreadcrumb'
        }
    ],
    state: {
        deposit_product: {
            type: null,
            subtype: null,
            depositIdentify: null,
            standard: null,
            preContractualAlias: BANKING_DEPOSIT_GENERIC_PRECONTRACTUAL,
            contractualAlias: BANKING_DEPOSIT_GENERIC_CONTRACTUAL,
            startDate: null,
            name: null,
            max: null,
            min: null,
            context: null,
        },
        isInfoModalOpen: false,
        card_details_title: 'contractsView-cardDetailsTitle',
        card_details: [
            {
                id: 'monto_traspasar',
                label: 'contractsView-amountToDeposit',
                value: null,
                type: 'single',
                format_type: EURO_SYMBOL,
                formatNumber: true,
                confirmation_step: {
                    columns: 3,
                    highlighted: true,
                    order: 1,
                    row: 1
                },
                visible: [
                    {
                        step: 1,
                        order: 1
                    },
                    {
                        step: 2,
                        order: 1
                    },
                    {
                        step: 3,
                        order: 1
                    },
                    {
                        step: 4,
                        order: 1
                    }
                ]
            },
            ...(showGrossInterest ? {
                id: 'gross_interest',
                label: 'contractsView-grossInterest',
                value: null,
                type: 'single',
                featureFlags: [DEPOSITS_INTEREST_BAND_COUNTRIES],
                format_type: EURO_SYMBOL,
                formatNumber: true,
                confirmation_step: {
                    columns: 3,
                    highlighted: true,
                    order: 1,
                    row: 1
                },
                visible: [
                    {
                        step: 1,
                        order: 1
                    },
                    {
                        step: 2,
                        order: 1
                    },
                    {
                        step: 3,
                        order: 1
                    },
                    {
                        step: 4,
                        order: 1
                    }
                ]
            } : {}),
            {
                id: 'tin',
                label: 'contractsView-tin',
                format_type: PERCENTAGE_SYMBOL,
                value: null,
                type: 'single',
                formatNumber: true,
                notImportantValue: true,
                order: 2,
                visible: notAllowedTINCountriesRenewal && [
                    {
                        step: 1,
                        order: 2
                    },
                    {
                        step: 2,
                        order: 2
                    },
                    {
                        step: 3,
                        order: 2
                    },
                    {
                        step: 4,
                        order: 2
                    }
                ]
            },
            {
                id: 'tae',
                label: 'contractsView-tae',
                value: null,
                format_type: PERCENTAGE_SYMBOL,
                type: 'single',
                order: 3,
                formatNumber: true,
                notImportantValue: true,
                visible: notAllowedTAECountriesRenewal && [
                    {
                        step: 1,
                        order: 3
                    },
                    {
                        step: 2,
                        order: 3
                    },
                    {
                        step: 3,
                        order: 3
                    },
                    {
                        step: 4,
                        order: 3
                    }
                ]
            },
            {
                id: 'expiration',
                label: 'contractsView-endDate',
                value: null,
                type: 'single',
                order: 4,
                format_type: '',
                visible: [
                    {
                        step: 1,
                        order: 3
                    },
                    {
                        step: 2,
                        order: 3
                    },
                    {
                        step: 3,
                        order: 3
                    },
                    {
                        step: 4,
                        order: 3
                    }
                ]
            },
            {
                id: 'installment',
                label: 'contractsView-installment',
                value: null,
                type: 'single',
                order: 6,
                format_type: '',
                isLanguageString: true,
                visible: [
                    {
                        step: 1,
                        order: 3
                    },
                    {
                        step: 2,
                        order: 3
                    },
                    {
                        step: 3,
                        order: 3
                    },
                    {
                        step: 4,
                        order: 3
                    }
                ]
            },
            {
                type: 'separator',
                order: 7,
                visible: [
                    {
                        step: 1,
                        order: 4
                    },
                    {
                        step: 2,
                        order: 4
                    },
                    {
                        step: 3,
                        order: 4
                    },
                    {
                        step: 4,
                        order: 4
                    }
                ]
            },
            {
                id: 'cta_seleccionada',
                label: 'contractsView-associatedAccount',
                value: null,
                type: 'single',
                format_type: '',
                order: 3,
                visible: [
                    {
                        step: 1,
                        order: 4
                    },
                    {
                        step: 2,
                        order: 4
                    },
                    {
                        step: 3,
                        order: 4
                    },
                    {
                        step: 4,
                        order: 4
                    }
                ],
                isErrorVisible: false
            },
            {
                id: 'balance_account',
                label: 'contractsView-accountBalanceAssociated',
                value: null,
                type: 'single',
                format_type: EURO_SYMBOL,
                formatNumber: true,
                order: 5,
                visible: [
                    {
                        step: 1,
                        order: 5
                    },
                    {
                        step: 2,
                        order: 5
                    },
                    {
                        step: 3,
                        order: 5
                    },
                    {
                        step: 4,
                        order: 5
                    }
                ]
            },
            {
                id: 'intervinientes_list',
                label: 'contractsView-interveners',
                value: null,
                type: 'interveners',
                format_type: '',
                confirmation_step: {
                    columns: 4,
                    order: 1,
                    row: 2
                },
                order: 6,
                visible: [
                    {
                        step: 1,
                        order: 6
                    },
                    {
                        step: 2,
                        order: 6
                    },
                    {
                        step: 3,
                        order: 6
                    },
                    {
                        step: 4,
                        order: 6
                    }
                ]
            },
            {
                id: 's_accounts',
                label: '',
                value: null,
                type: 'array',
                format_type: '',
                order: 10,
                visible: []
            },
            {
                id: 'n_steps',
                label: '',
                value: 4,
                type: 'array',
                format_type: '',
                order: 10,
                visible: []
            },
            {
                id: 'renewDeposit',
                label: '',
                value: false,
                format_type: '',
                order: 10,
                visible: []
            },
            {
                id: 'accountModal',
                openModal: false,
                value: false,
                format_type: '',
                order: 10,
                visible: []
            },
            {
                id: 'perLiq',
                value: '',
                format_type: '',
                order: 10,
                visible: []
            },
            {
                id: 'hasAccountPreselected',
                value: true
            }
        ],
        confirmationCheckboxes: {
            areValid: false,
            list: [
                {
                    id: 'service_contract_checkbox',
                    idName: 'serviceContract',
                    value: false,
                    isRequired: true,
                    errorState: false,
                    errorMessage: 'contractsView-serviceContractErrorMessage',
                    labels: __CONTACT_CENTER__ ? [
                        {
                            text: 'mainDepositFlow-mainDepositFlow_depositExpiredConfirmationCheckboxes1CC'
                        },
                        {
                            text: 'mainDepositFlow-mainDepositFlow_depositExpiredConfirmationCheckboxes2CC',
                            id: 'btn_contractsView_deposit-dynamic-contractual-doc',
                        }
                    ]: [
                        {
                            text: 'mainDepositFlow-mainDepositFlow_depositExpiredConfirmationCheckboxes1'
                        },
                        {
                            text: 'mainDepositFlow-mainDepositFlow_depositExpiredConfirmationCheckboxes2',
                            id: 'btn_contractsView_deposit-dynamic-contractual-doc',
                        },
                        {
                            text: 'mainDepositFlow-mainDepositFlow_depositExpiredConfirmationCheckboxes3'
                        }
                    ]
                }
            ]
        },
        precontractualConfirmationLabel: [
            {
                text: 'contractsView-contractsView_depositExpiredPrecontractualText1'
            },
        ],
        preContractDocuments : {
            preContractPdfFileName: formatText('contractsView-contractsView_depositWNMContractualDownload'),
            preContractPdfTitle: formatText('contractsView-depositWNMStep1Title')
        },
        preContractConditionsDocuments: {
            preContractPdfFileName: formatText('contractsView-contractsView_depositWNMPrecontractualDownload'),
            preContractPdfTitle: formatText('contractsView-depositWNMStep1Title'),
        },
    },
    steps: [step1, step2, step3],
    successStep: successStep(showGrossInterest),
    customErrors
});

module.exports = {
    getContract
};

